// Description: Topbanner js includes:

export function links_with_title($myBlockIdentifier) {
    $myBlockIdentifier.find('.toggle-footer-links ').on('click', function onClick(e) {
        $(this).toggleClass('is-closed').parent().next('.toggle-links').toggle(300);
        e.preventDefault();
    });
}
